// Used task-category-dialog.component.html

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

// RXJS/Store
import * as profileStore from "#login/store";
import { Store, select } from "@ngrx/store";

// Services/Types/Helpers
import { GetBookshelfUrlHelper } from "#helpers/get-bookshelf-url.helper";
import { Asset, assetTypeIds, eBookActivity, eReader } from "@carnegie-learning/cure-types";
import { AssetTypeHelper, PPUser as User } from "cli-types";

@Component({
    selector: "composite-tasks",
    templateUrl: "./composite-tasks.component.html",
    styleUrls: ["./composite-tasks.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompositeTasksComponent implements OnInit {
    @Input() compositeTasks: Asset[];

    userProfile: User;
    embedUrl: any;
    readonly assetTypeIds = assetTypeIds;

    constructor(
        private assetTypeHelper: AssetTypeHelper,
        public profile_store: Store<profileStore.UserState>,
        private getBookshelfUrl: GetBookshelfUrlHelper,
        private domSanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        this.profile_store
            .pipe(select(profileStore.getUserProfile))
            .subscribe((userProfile: User) => {
                if (userProfile) {
                    this.userProfile = userProfile;
                }
            });
    }

    trackByTask(index: number, task: Asset) {
        return task.assetId;
    }

    getIconPath(asset: Asset) {
        if (asset.assetActivityTypeId) {
            return this.assetTypeHelper.convertShortAssignableTypeToIconPath(
                asset.assetActivityTypeId
            );
        }
        return this.assetTypeHelper.convertShortAssignableTypeToIconPath(
            asset.assetTypeId
        );
    }

    openTask(asset: Asset) {
        let url: string;
        url = this.getBookshelfUrl.activity(
            <eBookActivity | eReader>asset,
            this.userProfile,
            null,
            null
        );
        this.embedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
